import { render } from "./LoadingOverlay.vue?vue&type=template&id=1d96591c"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"
script.render = render

export default script